import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
import { setError } from "./errorSlice";
export const fetchSchoolBatch = createAsyncThunk(
  "batch/fetchSchoolBatch",
  async (schoolId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/Batch/School/${schoolId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch batches");
      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const fetchParentBatch = createAsyncThunk(
  "batch/fetchParentBatch",
  async (accId, { rejectWithValue, dispatch }) => {
    try {
      console.log("accId", accId);

      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      console.log("token", token);
      console.log("path", `${API_BASE_URL}/api/Batch/Parent/${accId}`);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/Batch/Parent/${accId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch batches");
      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchStudentBatch = createAsyncThunk(
  "batch/fetchStudentBatch",

  async (accId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/Batch/Student/${accId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch batches");
      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);


export const fetchAllBatches = createAsyncThunk(
  "batch/fetchAllBatches",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      //     console.log("Attempting to fetch batches...");
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      //      console.log("path-----------", `${API_BASE_URL}/api/Batch`);
      const response = await fetch(`${API_BASE_URL}/api/Batch`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      //      console.log("Fetch response:", response);
      if (!response.ok) throw new Error("Failed to fetch batches");
      const data = await response.json();
      //     console.log("Fetched batches:", data);
      return data;
    } catch (error) {
      console.error("Error fetching batches:", error);
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const createBatch = createAsyncThunk(
  "batch/createBatch",
  async (batchData, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Batch/Create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          batchName: batchData.batchName,
          schoolId: batchData.schoolId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to create batch");
      }

      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const updateBatch = createAsyncThunk(
  "batch/updateBatch",
  async ({ batchId, batch }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Batch/Update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          batchId,
          batchName: batch.batchName,
          schoolId: batch.schoolId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update batch");
      }

      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const deleteBatch = createAsyncThunk(
  "batch/deleteBatch",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Batch/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to delete batch");
      }

      return id;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

const batchSlice = createSlice({
  name: "batches",
  initialState: {
    batches: [],
    filteredBatches: [],
    loading: false,
    error: null,
    editingBatch: null,
    modalVisible: false,
  },
  reducers: {
    setEditingBatch(state, action) {
      state.editingBatch = action.payload;
      state.modalVisible = true;
    },
    clearEditingBatch(state) {
      state.editingBatch = null;
      state.modalVisible = false;
    },
    filterBatchesBySchool(state, action) {
      const schoolId = action.payload;
      if (schoolId) {
        state.filteredBatches = state.batches.filter(
          (batch) => batch.schoolId === schoolId
        );
      } else {
        state.filteredBatches = state.batches;
      }
    },
    clearBatchFilter(state) {
      state.filteredBatches = state.batches;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBatches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllBatches.fulfilled, (state, action) => {
        state.loading = false;
        console.log("batch action.payload", action.payload);
        state.batches = action.payload;
        state.filteredBatches = action.payload;
        state.error = null;
      })
      .addCase(fetchAllBatches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSchoolBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchoolBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.batches = action.payload;
        state.filteredBatches = action.payload;
      })
      .addCase(fetchSchoolBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchParentBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParentBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.batches = action.payload;
        state.filteredBatches = action.payload;
      })
      .addCase(fetchParentBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchStudentBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.batches = action.payload;
        state.filteredBatches = action.payload;
      })
      .addCase(fetchStudentBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.batches.push(action.payload);
        state.filteredBatches = state.batches;
        state.modalVisible = false;
        state.editingBatch = null;
      })
      .addCase(createBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBatch.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.batches.findIndex(
          (batch) => batch.batchId === action.payload.batchId
        );
        if (index !== -1) {
          state.batches[index] = action.payload;
          state.filteredBatches = state.batches;
        }
        state.modalVisible = false;
        state.editingBatch = null;
      })
      .addCase(updateBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.batches = state.batches.filter(
          (batch) => batch.batchId !== action.payload
        );
        state.filteredBatches = state.batches;
      })
      .addCase(deleteBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setEditingBatch,
  clearEditingBatch,
  filterBatchesBySchool,
  clearBatchFilter,
} = batchSlice.actions;
export default batchSlice.reducer;
